module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"greeting":"Hi  {name}","my-bookings":"My Bookings","tab_member_information":"Member Information","tab_bookings":"Bookings","tab_coupons":"Coupons","tab_booking_passes":"Booking Passes"},"zh":{"greeting":"您好 {name}","my-bookings":"目前預約","tab_member_information":"會員資訊","tab_bookings":"預約紀錄","tab_coupons":"優惠券","tab_booking_passes":"課卡"}}')
  delete Component.options._Ctor
}
